import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getOperationModeSummary({ start, end, devcId }) {
    return axiosInstance.get(`/summary/operation_mode/${start}/${end}`, {
      params: {
        devcId,
      },
      cancelToken: getNewCancelToken(),
    });
  },

  getOperationModeSeries({ start, end, devcId }) {
    return axiosInstance.get(`/summary/operation_mode/series/${start}/${end}`, {
      params: {
        devcId,
      },
      cancelToken: getNewCancelToken(),
    });
  },
};
